import { useEffect, useState, useContext } from "react";
import { PortalContext } from "../../../context/Provider";
import { showToaster } from "../../../../global/context/action/toaster/toaster.js";
import {
  resetPaciente,
  wsPostActualizarClave,
} from "../../../context/Actions/paciente/paciente";
import { regexNumero } from "../../../../global/utils/expresionesRegulares";
import { setUsuario } from "../../../context/Actions/registro/registro";
import sliceInput from "../../../../global/utils/sliceInput";
import HidePassIcon from "../../../assets/images/generico/HidePassIcon";
import ShowPassIcon from "../../../assets/images/generico/ShowPassIcon";
import "./CambioPassword.css";
import { GlobalContext } from "../../../../global/context/Provider";
import InputV1 from "../../Genericos/InputV1/InputV1";

// Agregado: teclado alfanumérico (solo tablet/desktop)
import styled from "styled-components";
import Keyboard from "_+_Portal/components/Genericos/Keyboard/Keyboard";
import { hideModal } from "_+_Portal/context/Actions/modal/modal";

const TecladoWrapper = styled.div`
  padding: 20px 0;
  background-color: var(--color-latex10);
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const TecladoInner = styled.div`
  width: 460px;
  max-width: 95vw;
  overflow: visible;
`;

const CambioPasswordPaso3 = ({
  titulo,
  token,
  dissmiss,
  pathModal,
  pasoModal,
  texto,
  navigateTo,
}) => {
  const {
    pacienteDispatch,
    pacienteState,
    registroState,
    registroDispatch,
    modalDispatch,
  } = useContext(PortalContext);

  // Toaster en global
  const { toasterDispatch } = useContext(GlobalContext);

  const [nuevoPassword, setNuevoPassword] = useState("");
  const [repitoPassword, setRepitoPassword] = useState("");
  const [nuevoPasswordError, setNuevoPasswordError] = useState(false);
  const [repitoPasswordError, setRepitoPasswordError] = useState(false);
  const [passwordShown, setPasswordShown] = useState(false);
  const [passwordShownRepeat, setPasswordShownRepeat] = useState(false);
  const [codigoPaciente, setCodigoPaciente] = useState(
    pacienteState?.paciente?.data?.idPaciente
  );

  // Mostrar teclado solo en tablet/desktop y trackear foco del input activo
  const [isTabletOrDesktop, setIsTabletOrDesktop] = useState(
    typeof window !== "undefined" ? window.innerWidth >= 768 : true
  );
  useEffect(() => {
    const onResize = () => setIsTabletOrDesktop(window.innerWidth >= 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // Estado para trackear el input activo y su valor (para el teclado virtual)
  const [activeInputName, setActiveInputName] = useState("txtNuevoPassword");
  const [activeInputValue, setActiveInputValue] = useState("");

  // Sincronizar activeInputValue con los estados de los inputs
  useEffect(() => {
    if (activeInputName === "txtNuevoPassword") {
      setActiveInputValue(nuevoPassword);
    } else if (activeInputName === "txtRepitoPassword") {
      setActiveInputValue(repitoPassword);
    }
  }, [nuevoPassword, repitoPassword, activeInputName]);

  useEffect(() => {
    const onFocusIn = (e) => {
      const t = e.target;
      if (t && t.tagName === "INPUT" && t.name) {
        setActiveInputName(t.name);
      }
    };

    document.addEventListener("focusin", onFocusIn);

    // Fijar input activo inicial
    const initialEl = document.getElementsByName("txtNuevoPassword")[0];
    if (initialEl) {
      setActiveInputName("txtNuevoPassword");
    }

    return () => {
      document.removeEventListener("focusin", onFocusIn);
    };
  }, []);

  const onPasswordPress = (e) => {
    if (!regexNumero.test(e.key)) {
      e.preventDefault();
    }
    if (e.target.name === "txtNuevoPassword") {
      if (e.key === "Enter") {
        document.getElementsByName("txtRepitoPassword")[0].focus();
      }
    }
  };

  const showPassword = () => {
    setPasswordShown(true);
  };
  const hidePassword = () => {
    setPasswordShown(false);
  };

  const showPasswordRepeat = () => {
    setPasswordShownRepeat(true);
  };
  const hidePasswordRepeat = () => {
    setPasswordShownRepeat(false);
  };

  const isPasswordValido = (password) => {
    if (password === "") {
      return true;
    }
    return false;
  };

  const onNuevoPasswordChange = (e) => {
    sliceInput(e);
    setNuevoPasswordError(isPasswordValido(e.target.value));
    setNuevoPassword(e.target.value);
  };

  const onRepitoPasswordChange = (e) => {
    sliceInput(e);
    setRepitoPasswordError(isPasswordValido(e.target.value));
    setRepitoPassword(e.target.value);
  };

  const confirmarPassword = () => {
    if (nuevoPassword.length >= 4 || repitoPassword.length >= 4) {
      if (
        nuevoPassword === repitoPassword &&
        nuevoPassword !== "" &&
        repitoPassword !== ""
      ) {
        wsPostActualizarClave(
          nuevoPassword,
          repitoPassword,
          codigoPaciente,
          token,
          nextStepClave
        )(pacienteDispatch);

        // MODIFICAR ESTA LOGICA ESTA MALLLLLLL
        let usuario = Object.assign({}, registroState.registro.usuario);
        usuario.telefono = repitoPassword;
        setUsuario(usuario)(registroDispatch);
      } else {
        showToaster(
          {
            texto:
              "Las contraseñas no coinciden, ingresá los campos solicitados.",
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
      }
    } else {
      showToaster(
        {
          texto: "La contraseña debe tener al menos 4 caracteres numéricos",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    }
  };

  const nextStepClave = (isCorrect, data) => {
    if (isCorrect) {
      hideModal()(modalDispatch);
      showToaster(
        {
          texto: "Clave actualizada",
          tipo: "success",
        },
        "centroArriba"
      )(toasterDispatch);
      sessionStorage.setItem("claveVerificada", "true");
      navigateTo(pathModal, pasoModal);
    } else {
      showToaster(
        {
          texto: "Error al actualizar clave",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    }
  };

  useEffect(() => {
    document.getElementsByName("txtNuevoPassword")[0].focus();
  }, []);

  useEffect(() => {
    if (
      pacienteState.paciente.error !== null &&
      pacienteState.paciente.error !== undefined &&
      pacienteState.paciente.error.origen === "cambioClave" &&
      pacienteState.paciente.error !== false
    ) {
      if (
        pacienteState.paciente.error.status !== null &&
        pacienteState.paciente.error.status !== undefined &&
        pacienteState.paciente.error.origen === "cambioClave"
      ) {
        if (
          pacienteState.paciente.error.texto !== undefined &&
          pacienteState.paciente.error.texto !== null &&
          pacienteState.paciente.error.texto !== ""
        ) {
          showToaster(
            {
              texto: pacienteState.paciente.error.texto,
              tipo: "danger",
            },
            "centroArriba"
          )(toasterDispatch);
          resetPaciente()(pacienteDispatch);
        } else {
          showToaster(
            {
              texto: "La contraseña es incorrecta",
              tipo: "danger",
            },
            "centroArriba"
          )(toasterDispatch);
          resetPaciente()(pacienteDispatch);
        }
      }
    }
    //eslint-disable-next-line
  }, [pacienteState.paciente.error]);

  // Helpers para el teclado virtual
  const sanitizeNumeric = (v) => (v || "").replace(/[^0-9]/g, "");

  // Actualiza el input activo desde el teclado virtual
  const updateActiveInputValue = (newValue) => {
    if (!activeInputName) return;
    const el = document.getElementsByName(activeInputName)[0];
    if (!el) return;

    const maxLen = typeof el.maxLength === "number" ? el.maxLength : -1;
    const sanitized = sanitizeNumeric(newValue);
    const finalValue =
      maxLen > -1 && sanitized.length > maxLen
        ? sanitized.slice(0, maxLen)
        : sanitized;

    if (document.activeElement !== el) {
      el.focus();
    }

    // Actualizar el estado del valor del input activo para el teclado
    setActiveInputValue(finalValue);

    // Actualizar los estados de React según el input activo
    if (activeInputName === "txtNuevoPassword") {
      setNuevoPassword(finalValue);
      setNuevoPasswordError(isPasswordValido(finalValue));
    } else if (activeInputName === "txtRepitoPassword") {
      setRepitoPassword(finalValue);
      setRepitoPasswordError(isPasswordValido(finalValue));
    }
  };

  // Maneja cambio desde el teclado virtual
  const handleKeyboardChange = (value) => {
    if (typeof value !== "string") return;
    updateActiveInputValue(value);
  };

  // Enter del teclado: valida que ambos campos estén completos antes de confirmar
  const handleKeyboardEnter = () => {
    // Si el primer input tiene contenido pero el segundo está vacío, hacer focus en el segundo
    if (nuevoPassword && nuevoPassword.length >= 4 && !repitoPassword) {
      const el2 = document.getElementsByName("txtRepitoPassword")[0];
      if (el2) el2.focus();
      return;
    }

    // Si el segundo input tiene contenido pero el primero está vacío, hacer focus en el primero
    if (repitoPassword && repitoPassword.length >= 4 && !nuevoPassword) {
      const el1 = document.getElementsByName("txtNuevoPassword")[0];
      if (el1) el1.focus();
      return;
    }

    // Si ambos inputs están completos (al menos 4 caracteres), confirmar
    if (
      nuevoPassword &&
      nuevoPassword.length >= 4 &&
      repitoPassword &&
      repitoPassword.length >= 4
    ) {
      confirmarPassword();
    }
  };

  return (
    <>
      <div className="ptur-modal-password modalHeader bgcG-latex30">
        <h1 className="modalTitle rb18b c-white">
          {titulo === "" ? "Error en el sistema" : titulo}
        </h1>
        <div className="cruz" onClick={dissmiss}>
          <div className="cruzParte1"></div>
          <div className="cruzParte2"></div>
        </div>
      </div>
      <div className="ptur-modal-password-general">
        <div className="ptur-modal-password-modalBody">
          <h3 className="ptur-modal-texto rb16m c-latex10">
            La contraseña debe contener solo valores numéricos
          </h3>
          <h3 className="rb16t c-latex10">{texto === "" ? "" : texto}</h3>
          <div className="ptur-modal-input">
            <InputV1
              headerStr="Nueva contraseña"
              placeholderText="23756"
              inputType="number"
              name="txtNuevoPassword"
              errorStr="La contraseña es inválida."
              onChange={onNuevoPasswordChange}
              onKeyPress={onPasswordPress}
              value={nuevoPassword}
              className={
                passwordShown
                  ? "inputNumericShow inputNonScroll rb16m"
                  : "inputNumeric inputNonScroll rb16m"
              }
              maxLength="10"
              checkError={nuevoPasswordError}
              isRequired={true}
              pattern={"[0-9]*"}
              inputMode={"numeric"}
            />
            {passwordShown === false ? (
              <>
                <button
                  className="ptur-modal-password-show-hideBtn"
                  onClick={() => showPassword()}
                >
                  <HidePassIcon color="var(--color-latex30)" />
                </button>
              </>
            ) : (
              <>
                <button
                  className="ptur-modal-password-show-hideBtn"
                  onClick={() => hidePassword()}
                >
                  <ShowPassIcon color="var(--color-latex30)" />
                </button>
              </>
            )}
          </div>
          <div className="ptur-modal-input">
            <InputV1
              headerStr="Repita la nueva contraseña"
              placeholderText="23756"
              inputType="number"
              name="txtRepitoPassword"
              errorStr="La contraseña es inválida."
              onChange={onRepitoPasswordChange}
              onKeyPress={onPasswordPress}
              value={repitoPassword}
              className={
                passwordShownRepeat
                  ? "inputNumericShow inputNonScroll rb16m"
                  : "inputNumeric inputNonScroll rb16m"
              }
              maxLength="10"
              checkError={repitoPasswordError}
              isRequired={true}
              pattern={"[0-9]*"}
              inputMode={"numeric"}
            />
            {passwordShownRepeat === false ? (
              <>
                <button
                  className="ptur-modal-password-show-hideBtn"
                  onClick={() => showPasswordRepeat()}
                >
                  <HidePassIcon color="var(--color-latex30)" />
                </button>
              </>
            ) : (
              <>
                <button
                  className="ptur-modal-password-show-hideBtn"
                  onClick={() => hidePasswordRepeat()}
                >
                  <ShowPassIcon color="var(--color-latex30)" />
                </button>
              </>
            )}
          </div>
          <button
            className={`${
              (nuevoPassword?.length >= 4) & (repitoPassword?.length >= 4)
                ? "bgc-broccoli"
                : "bgc-grey65"
            } btnCambioPassword rb18m`}
            onClick={() => confirmarPassword()}
          >
            Confirmar y actualizar
          </button>
        </div>
        {isTabletOrDesktop && (
          <TecladoWrapper>
            <TecladoInner>
              {/* <TecladoAlfanumerico
              sinNumeros={false}
              modeLight={true}
              onEnter={handleKeyboardEnter}
              enterStr={"Enter"}
              onChange={handleKeyboardChange}
              maxLength={20}
              onDelete={handleKeyboardDelete}
              onKey={handleKeyboardKey}
            /> */}

              <Keyboard
                value={activeInputValue}
                onChange={handleKeyboardChange}
                onEnter={handleKeyboardEnter}
                maxLength={20}
                enableFrom={4}
                enterText={"OK"}
              />
            </TecladoInner>
          </TecladoWrapper>
        )}
      </div>
    </>
  );
};

export default CambioPasswordPaso3;
